import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
// import { WrapperContext } from "./Layout";
import Menu from "./Menu";
import Nuancier from "./Nuancier";
import MenuShop from "./MenuShop";
import clsx from "clsx";
import PubSub from "pubsub-js";
// import asphaltChroniclesLogo from "../images/asphalt-chronicles-logo.svg";

const query = graphql`
  query {
    sanityHeader {
      siteName
      nav {
        label
        rel
        link {
          ... on SanityPageModulaire {
            title
            home
            slug {
              current
            }
          }
        }
      }
    }
  }
`;

const Header = () => {
  // const { isHome } = useContext(WrapperContext);
  const [hide, setHide] = useState(false);
  const { sanityHeader } = useStaticQuery(query);
  const { siteName, nav } = sanityHeader;

  useEffect(() => {
    document.addEventListener("keyup", _onKey);

    return () => document.removeEventListener("keyup", _onKey);
  }, [hide]);

  const _onKey = e => {
    // console.log(e.keyCode);
    if (e.keyCode === 75) setHide(!hide);
    if (e.keyCode === 27) PubSub.publish("ESC");
    if (e.keyCode === 39) PubSub.publish("KB_NEXT");
    if (e.keyCode === 37) PubSub.publish("KB_PREV");
  };
  // console.log(nav);
  return (
    <header id='site-header' className={clsx(hide ? "hide" : "")}>
      <div className='flex flex-col md:flex-row'>
        <div className='md:col-6-13 z-10 '>
          <div className='top-header bg-white pl-sm md:pl-md '>
            <div className='flex justify-between'>
              <h1 className='site-name'>
                <Link to='/'>
                  {/* <Link to='/'> */}
                  <div className='site-name--text whitespace-nowrap'>
                    {siteName}
                  </div>
                </Link>
              </h1>
              <Menu input={nav} />
            </div>
          </div>
        </div>
        <div className='md:col-7-13 z-0'>
          <Nuancier />
          <MenuShop />
        </div>
      </div>
    </header>
  );
};

export default Header;
